import React from "react";

export const DisableReloadIcon = (props) => {
  return (
    <>
      <svg
        width={20}
        height={18}
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M11.1895 0.125C6.7395 0.125 3.10574 3.72171 2.89674 8.22024H0.501953L4.46029 13.5833L8.41862 8.22024H6.06341C6.26687 5.50752 8.48591 3.3631 11.1895 3.3631C14.0268 3.3631 16.3353 5.72367 16.3353 8.625C16.3353 11.5263 14.0268 13.8869 11.1895 13.8869C9.71458 13.8869 8.38537 13.245 7.44645 12.225L5.52508 14.8284C7.01104 16.2483 8.9997 17.125 11.1895 17.125C15.7732 17.125 19.502 13.3121 19.502 8.625C19.502 3.93786 15.7732 0.125 11.1895 0.125Z"
          fill="#CECECE"
          style={{
            fill: "#CECECE",
            fill: "color(display-p3 0.8097 0.8097 0.8097)",
            fillOpacity: 1,
          }}
        />
      </svg>
    </>
  );
};
